import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { FormControlDesktop } from '../../../form-control/esm/desktop';
import { BaseInput } from '../components/base-input/Component.js';
import 'react-merge-refs';
import 'classnames';
import '../../../shared/esm';
import '../../../status-badge/esm';
import '@alfalab/hooks';
import '../components/clear-button/Component.js';
import '../../../button/esm';
import '@alfalab/icons-glyph/CrossCircleMIcon';

var InputDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseInput, __assign({}, restProps, { FormControlComponent: FormControlDesktop, ref: ref }))); });

export { InputDesktop };
